import React from 'react'
import Wpw from './Wpw/Wpw'
import Projects from './Projects/Projects'

function Product() {
  return (
    <>
      <Wpw />
      <Projects />
    </>
  )
}

export default Product
